import { request } from '@/api/index';
export function assess(data) {
  return request({
    url: '/api/Common/Assess',
    method: 'get',
    params: data
  });
}